import { render, staticRenderFns } from "./PdpAddToCart.vue?vue&type=template&id=e48397ce&"
import script from "./PdpAddToCart.vue?vue&type=script&lang=js&"
export * from "./PdpAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppAddToCart: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppAddToCart.vue').default,PdpStickyHeader: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpStickyHeader.vue').default})
